export enum SARSDistributionType {
    BO = 1,
    PT = 2,
}